const STORAGE_KEY = 'savedLoginAccounts'
const MAX_ACCOUNTS = 3

export function getSavedAccounts() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    return saved ? JSON.parse(saved) : []
  } catch {
    return []
  }
}

export function saveAccount({ name, email }) {
  if (!email) return

  const accounts = getSavedAccounts().filter(a => a.email !== email)
  accounts.unshift({ name: name || email.split('@')[0], email })
  localStorage.setItem(STORAGE_KEY, JSON.stringify(accounts.slice(0, MAX_ACCOUNTS)))
}

export function removeAccount(email) {
  const accounts = getSavedAccounts().filter(a => a.email !== email)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(accounts))
}

export function clearAllAccounts() {
  localStorage.removeItem(STORAGE_KEY)
}
